import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import Day from './Day';
import Week from './Week';
import Month from './Month';
import useAppointmentGql from '../../wedding-wardrobe/src/components/appointments/hooks/useAppointmentGql';
import { filterAppointmentsFor } from '../utils/filterAppointments';
import CoolLoading from '../../wedding-wardrobe/src/components/base/CoolLoading';
import useRefetchContext from '../ui/refetch/useRefetchContext';
import { alterationAppointmentTypes, appointmentTypes } from '../utils/appointmentTypes';

function CalendarView(props) {
  const { calendarViewType, calendar, onWeekDayClick, children, displaySideHours, displayHourCase, onCalendarCaseClick, highlightToday, admin = true, selectedCalendarDay,
    setSelectedCalendarDay, setDate, navigations, setAvailabilities, alterations, alterationRange = {}, appointmentType } = props;
  const { setRefetch } = useRefetchContext();
  const beginningOf = `beginningOf${calendarViewType}`;
  const endOf = `endOf${calendarViewType}`;
  const { day, daysOfWeek, openingHours, [beginningOf]: from, [endOf]: to } = calendar;

  const commonProps = { sideHours: openingHours, displayHourCase, displaySideHours, onCalendarCaseClick };
  const aTypes = alterations ? [...alterationAppointmentTypes] : appointmentTypes;
  const filters = {
    reverse: false,
    sortKey: 'created_at',
    status: '-1',
    query: '',
    dateFrom: from.date,
    dateTo: to.date,
    appointmentTypes: aTypes,
    stylistId: '-1',
  };

  const { loading, data, error, refetch } = useAppointmentGql().useAppointmentCalendarFragmentQuery(filters, admin);

  useEffect(() => {
    if (data) {
      setRefetch(refetch);
    }
  }, [data]);

  if (error) console.log({ error });
  if (loading) return <CoolLoading />;

  const { appointments } = data ?? { appointments: [] };

  const toRenderHourCell = (o) => {
    const { availability, utcDatetime } = o;
    if (availability === undefined) {
      return children({ appointments: filterAppointmentsFor(calendarViewType, utcDatetime, appointments) });
    }
    return children(o);
  };

  const ViewType = () => {
    switch (calendarViewType) {
      case 'Day':
        return (
          <Day
            day={day}
            type="Day"
            {...commonProps}
          >
            {toRenderHourCell}
          </Day>
        );
      case 'Week':
        return (
          <Week
            daysOfWeek={daysOfWeek}
            onWeekDayClick={onWeekDayClick}
            highlightToday={highlightToday}
            {...commonProps}
          >
            {toRenderHourCell}
          </Week>
        );
      case 'Month':
        return (
          <Month
            calendar={calendar}
            onWeekDayClick={onWeekDayClick}
            admin={admin}
            selectedCalendarDay={selectedCalendarDay}
            setSelectedCalendarDay={setSelectedCalendarDay}
            setDate={setDate}
            navigations={navigations}
            setAvailabilities={setAvailabilities}
            alterationRange={alterationRange}
            appointmentType={appointmentType}
          >
            {/* eslint-disable-next-line no-shadow */}
            {toRenderHourCell}
          </Month>
        );
      default:
        return null;
    }
  };

  return (
    <ViewType />
  );
}

CalendarView.defaultProps = {
  displaySideHours: true,
  displayHourCase: true,
  onCalendarCaseClick: null,
  highlightToday: false,
};

CalendarView.propTypes = {
  displaySideHours: PropTypes.bool,
  displayHourCase: PropTypes.bool,
  onCalendarCaseClick: PropTypes.func,
  calendarViewType: PropTypes.string.isRequired,
  calendar: PropTypes.object.isRequired,
  onWeekDayClick: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
  highlightToday: PropTypes.bool,
};

export default CalendarView;
